import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { queryKeys } from '@/query/keys';

import {
  templateVariablesEndpoints,
  type TemplateVariableContext,
  type TemplateVariableDto,
} from './endpoints';

export type {
  TemplateVariableContext,
  TemplateVariableDataType,
  TemplateVariableDto,
  TemplateVariableGroup,
} from './endpoints';

/** The merge-field palette for an authoring context (e.g. {@code PPQ_EMAIL}). */
export function useTemplateVariables(
  context: TemplateVariableContext,
): UseQueryResult<TemplateVariableDto[]> {
  return useQuery<TemplateVariableDto[]>({
    queryKey: queryKeys.templateVariables(context),
    queryFn: ({ signal }) => templateVariablesEndpoints.getTemplateVariables(context, { signal }),
    staleTime: 10 * 60 * 1000,
  });
}
